import * as React from 'react'
import 'react-dates/initialize'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import * as constants from '../../../../static/constants'
import SvgIcon from 'components/atoms/SvgIcon'
import FavoriteButton from 'components/atoms/FavoriteButton'

interface IProps {
  editable: boolean
  post: any
  likeable: boolean
}

export const PostTop: React.FC<IProps> = props => {
  return (
    <PostTopWrap favoriteText={I18n.t('favorite.add')}>
      <div className="PostTop_Info">
        {props.post.area && (
          <div className="PostShow_Area">
            {I18n.t('post.guided_tour', { area: props.post.area.name_i18n })}
          </div>
        )}

        <h1 className="PostShow_Title">{props.post.name}</h1>

        <div className="PostShow_HeaderInfo">
          <div className="PostShow_HeaderInfo_Inner">
            <div className="ReviewCount">
              <SvgIcon name="star" className="icon" ariaHidden={true} role="presentation" />
              <span className="score">{props.post.average_review_score}</span>
              <span className="count">({props.post.reviews_count.toLocaleString()})</span>
            </div>

            <div className="EnjoyedPeopleCount">
              {props.post.experienced_count >= 0 && props.post.experienced_count <= 19 ? (
                <>
                  <SvgIcon name="awesome" className="icon" ariaHidden={true} role="presentation" />
                  <span className="newActivity">New activity</span>
                </>
              ) : (
                <>
                  <SvgIcon
                    name="check_circle_filled"
                    className="icon"
                    ariaHidden={true}
                    role="presentation"
                  />
                  {props.post.experienced_count >= 20 && props.post.experienced_count <= 999 ? (
                    <span className="actualNum">{props.post.experienced_count}</span>
                  ) : (
                    <span className="overNum">
                      {(Math.floor(props.post.experienced_count / 1000) * 1000).toLocaleString()}+
                    </span>
                  )}
                  <span>Booked</span>
                </>
              )}
            </div>
            {props.post.meeting_points && props.post.meeting_points[0] && (
              <a href="#mp_anchor" className="MeetingPoint">
                <SvgIcon
                  name="place_filled"
                  className="icon"
                  ariaHidden={true}
                  role="presentation"
                />
                <span>{props.post.meeting_points[0]?.name}</span>
              </a>
            )}
          </div>
          {props.likeable && (
            <div className="ToggleLike">
              <FavoriteButton post={props.post} />
            </div>
          )}
        </div>
      </div>
    </PostTopWrap>
  )
}
const PostTopWrap = styled.div`
  margin-bottom: 4rem;
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    margin: 2.4rem 0;
  }
  .PostShow_Area {
    line-height: 2.4rem;
    color: ${constants.COLORS.subText};
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 0.4rem;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      line-height: 2rem;
      font-size: 1.4rem;
      margin-bottom: 0;
    }
  }

  .PostShow_Title {
    line-height: 4.4rem;
    margin: 0 0 1.6rem;
    font-size: 3.2rem;
    font-weight: 700;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      line-height: 3.2rem;
      font-size: 2.2rem;
      margin-bottom: 0.8rem;
    }
  }

  .PostShow_HeaderInfo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    line-height: 2.4rem;
    font-size: 1.6rem;
    @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
      font-size: 1.4rem;
    }

    .PostShow_HeaderInfo_Inner {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0 2rem;
      .icon {
        margin-right: 0.4rem;
      }
      > div,
      > a {
        margin-bottom: 0.8rem;
      }
    }

    .ReviewCount {
      display: flex;
      align-items: center;
      .icon {
        color: ${constants.COLORS.useally};
      }
      .score {
        font-weight: 700;
      }
      .count {
        margin-left: 0.4rem;
        color: ${constants.COLORS.subText};
      }
    }


    .EnjoyedPeopleCount {
      display: flex;
      align-items: center;
      color: ${constants.COLORS.primary};
      font-weight: 700;
      .icon {
        color: ${constants.COLORS.primary};
        margin: 0;
      }
      span {
        color: ${constants.COLORS.black};
        margin-left: 0.4rem;
        &.newActivity,
        &.actualNum,
        &.overNum {
          color: ${constants.COLORS.primary};
        }
      }
    }
    .MeetingPoint {
      display: flex;
      align-items: center;
      text-decoration: underline;
      color: ${constants.COLORS.black};
      .icon {
        color: ${constants.COLORS.subText};
      }
      &:hover {
        text-decoration: none;
      }
    }
    .ToggleLike {
      margin-bottom: 0.8rem;
      .icon {
        width: 2.4rem;
        height: 2.4rem;
        color: ${constants.COLORS.danger};
        margin-right: 0.4rem;
      }
      div {
        display: flex;
        align-items: center;
        &::after {
          content: '${props => props.favoriteText}';
          color: ${constants.COLORS.black};
          text-decoration: underline;
        }
      }
      &:hover {
        div::after {
          text-decoration: none;
        }
      }
    }
  }
`
